import { createContext, useContext, useMemo, useState } from 'react';
import PropTypes from 'prop-types'
const LivrableContext = createContext();

export const LivrableProvider = ({ children }) => {
    const [livrables, setLivrables] = useState([]);
    const [livrable, setLivrable] = useState({
  
          
      
    });
  
    const setLivrableAttributes = (attributes) => {
      // Merge the new attributes with the existing ones
      setLivrable((prevLivrable) => ({ ...prevLivrable, ...attributes }));
    };
    // utilisation de useMemo pour éviter un re-render inutile du contexte 
    const value = useMemo(()=>({

      livrables, 
      setLivrables, 
      livrable, 
      setLivrableAttributes
    }),[livrables,livrable])
  
    return (
      <LivrableContext.Provider value={value}>
        {children}
      </LivrableContext.Provider>
    );
  };
  
  LivrableProvider.propTypes={
    children:PropTypes.node.isRequired
  }
  export const useLivrable = () => {
    return useContext(LivrableContext);
  };